import { render, staticRenderFns } from "./markDialog.vue?vue&type=template&id=fa02c162&scoped=true&"
import script from "./markDialog.vue?vue&type=script&lang=js&"
export * from "./markDialog.vue?vue&type=script&lang=js&"
import style0 from "./markDialog.vue?vue&type=style&index=0&id=fa02c162&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa02c162",
  null
  
)

export default component.exports